'use client';

import React, { FC } from 'react';
import toast from 'react-hot-toast';

import Toaster from '@/components/popups/Toaster';
import { useTranslation } from '@/hooks/useTranslations';

import './styles.scss';

interface ShareProps {
  close: (val: boolean) => void;
}

const Share: FC<ShareProps> = ({ close }) => {
  const link = window.location.href;
  const { t } = useTranslation();
  const copyLink = () => {
    navigator.clipboard.writeText(link);
    toast(<Toaster type="success" description="Link copied-Text" />, {
      duration: 3000,
    });
  };

  return (
    <div className="popupWrp">
      <div className="popupInner shareNews">
        <div className="popupInnerTitle">
          <div className="upcomingPopupTitleRow">
            <p className="upcomingPopupTitleText">{t('Share news-Text')}</p>
            <div className="upcomingPopupTitleCloseCont">
              <i className="bc-i-close upcomingPopupTitleCloseIcon" onClick={() => close(false)} />
            </div>
          </div>
        </div>
        <div className="popupInnerContent">
          <div className="upcomingPopupLogosRow">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="upcomingPopupLogosAround"
            >
              <i className="bc-i-facebook sharePopIcon" />
            </a>
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="upcomingPopupLogosAround"
            >
              <i className="bc-i-linkedin sharePopIcon" />
            </a>
          </div>
          <div className="upcomingPopupBottomRow">
            <p className="upcomingPopupBottomText">{t('or copy link-Text')}</p>
            <div className="upcomingPopupCopyLink">
              <p className="upcomingPopupCopyLinkTxt">{link}</p>
              <div className="upcomingPopupBtn">
                <button className="button btnTypeSmall btnTypeCopy" onClick={copyLink}>
                  <p>{t('Copy-Text')}</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Share;
